var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0138 37.8362H3.98628C0.862528 37.8362 -1.04247 34.405 0.607528 31.7537L19.1213 2.035C20.6775 -0.466255 24.3188 -0.466255 25.875 2.035L44.3888 31.7537C46.0425 34.405 44.1375 37.8362 41.0138 37.8362Z",
    fill: "#EC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4997 10.9525C20.4447 10.9525 18.8397 12.73 19.0497 14.7738L19.9085 23.1513C20.0435 24.4788 21.1647 25.4913 22.4997 25.4913C23.8347 25.4913 24.956 24.4825 25.091 23.1513L25.9497 14.7738C26.1597 12.73 24.5547 10.9525 22.4997 10.9525Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 28.2288C20.9555 28.2288 19.6992 29.4813 19.6992 31.03C19.6992 32.575 20.9517 33.8313 22.5005 33.8313C24.0492 33.8313 25.3017 32.5788 25.3017 31.03C25.3017 29.485 24.0455 28.2288 22.5005 28.2288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c8e0bb7ce2c2e8d649e15001929c9faa.svg";
export { ForwardRef as ReactComponent };